import { FC, useEffect, useState } from 'react';

interface TurnTimerProps {
  isActive: boolean;
  duration: number;
  onTimeout: () => void;
}

const TurnTimer: FC<TurnTimerProps> = ({ isActive, duration, onTimeout }) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (isActive) {
      setTimeLeft(duration);
      const timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            onTimeout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isActive, duration, onTimeout]);

  const percentage = (timeLeft / duration) * 100;

  return (
    <div className="relative w-full h-2 bg-gray-700 rounded overflow-hidden">
      <div
        className={`absolute inset-0 transition-all duration-1000 ${
          percentage > 66
            ? 'bg-green-500'
            : percentage > 33
            ? 'bg-yellow-500'
            : 'bg-red-500'
        }`}
        style={{ width: `${percentage}%` }}
      />
      <div className="absolute inset-0 flex items-center justify-center text-xs text-white font-bold">
        {timeLeft}s
      </div>
    </div>
  );
};

export default TurnTimer; 